export function NotIncludedBadge() {
  return (
    <div className="border-chariot-status-warning/30 bg-chariot-status-warning/10 text-chariot-status-warning rounded-full border px-2 py-0.5 text-xs font-medium">
      Not Included
    </div>
  );
}
